import {connect} from 'react-redux';
import AboutOverview from './AboutOverview';

export default connect((state) => ({
  userType: state.collegeProfile.userInfo.user,
}))(AboutOverview);
